export default class DummyController {
    constructor() { }
}
DummyController.$inject = [];
